import React, { useState } from 'react';
import { useEffect } from "react";
import ContactForm from '../../layouts/ContactForm';
import { Link } from 'react-router-dom'

const slides = [
    { id: 1, text: "Slide 1", color: "red", src: "assets/Agile_Consulting.png" },
    { id: 2, text: "Slide 2", color: "blue", src: "assets/DevSecOps_Consulting.png" },
    { id: 3, text: "Slide 3", color: "green", src: "assets/UI_UX_Consulting.png" },
    { id: 4, text: "Slide 4", color: "black", src: "assets/AI_Consulting.png" },

];

const slider1 = [
    { id: 1, text: "Slide 1", color: "red", src: "assets/movoto-background.png" }/* ,
    { id: 2, text: "Slide 2", color: "blue", src: "assets/Sagent_background.png" },
    { id: 3, text: "Slide 3", color: "green", src: "assets/Switchfly_Background.png" },
    { id: 4, text: "Slide 4", color: "black", src: "assets/AI_Consulting.png" }, */

];

const slider2 = [
    { id: 1, text: " challenges, slower site performance, and a corresponding erosion of customer experience", color: "red"  },
    { id: 2, text: "Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience", color: "blue"},
    { id: 3, text: "Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience", color: "green"},
    { id: 4, text: "Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience", color: "black"},

];

const ApplicationAndProductMaintanence = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
          }, []);

    /* sliders start*/
                    const [currentIndex, setCurrentIndex] = useState(0);
                    const visibleSlides = 3; // Number of slides to display at a time
                
                    const nextSlide = () => {
                        setCurrentIndex((prevIndex) =>
                            prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
                        );
                    };
                
                    const prevSlide = () => {
                        setCurrentIndex((prevIndex) =>
                            prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
                        );
                    };
                
                    /* sliders end*/
            
                    /* sliders-1 start*/
                        const [currentIndex1, setCurrentIndex1] = useState(0);
                        const visibleSlides1 = 3; // Number of slides to display at a time
                    
                        const nextSlide1 = () => {
                            setCurrentIndex((prevIndex) =>
                                prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
                            );
                        };
                    
                        const prevSlide1 = () => {
                            setCurrentIndex((prevIndex) =>
                                prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
                            );
                        };
                    
                        /* sliders-1 end*/
                    
            
                    /* slider-2 start */
                    
                        const [currentIndex2, setCurrentIndex2] = useState(0);
                        const visibleSlides2 = 3; // Number of slides to display at a time
                    
                        const nextSlide2 = () => {
                            setCurrentIndex((prevIndex) =>
                                prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
                            );
                        };
                    
                        const prevSlide2 = () => {
                            setCurrentIndex((prevIndex) =>
                                prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
                            );
                        };
                    
                        /* sliders-2 end */
    return (
        <>
            <div className="container-fluid service-banner">
                <h1>Application & product Management</h1>
                <hr />
                <p>Success doesn't stop at deployment. Discover the best practices and tools on how to maintain growth and efficiency.</p>
                <Link to="/contact-us"><button style={{ borderRadius: "10px", padding: "10px 30px 10px 30px", fontSize: "20px" }}>TALK TO AN EXPERT <i class="fas fa-arrow-right"></i></button></Link>
            </div>

            {/* <div className="container-fluid" style={{ paddingTop: "50px" }}>
                <div className="row">
                    <h1>What Our Clients Say About Us</h1>
                    <p>Explore our proven expertise and ability to deliver results through a diverse range of testimonials spanning across industries and unique requirements.
                    </p>
                    <div className="col-md-6 ">
                        <div className="client-says">
                            <img src="assets/Mike_Ackroyd.jpeg" style={{ width: "70px", height: "70px", borderRadius: "50%" }} className="float-left" />
                            <img src="assets/Biote-logo.png" style={{  height: "70px", borderRadius: "50%" }} className="float-right" />
                            <p style={{paddingLeft:"100px",marginBottom:"0px",marginTop:"10px"}}><strong>Joe butler</strong></p>
                            <p style={{paddingLeft:"100px"}}>cheif offices</p>
                            <hr />  
                            <p>"We selected Encora as our primary innovation partner because of their breadth of experience, depth of expertise, and consistent quality of service delivered by the team from their offshore center in the Philippines. Encora has been an integral part of our development and production support strategy."</p>
                        </div>
                    </div>
                    <div className="col-md-6 ">
                        <div className="client-says">
                            <img src="assets/Mike_Ackroyd.jpeg" style={{ width: "70px", height: "70px", borderRadius: "50%" }} className="float-left" />
                            <img src="assets/Biote-logo.png" style={{  height: "70px", borderRadius: "50%" }} className="float-right" />
                            <p style={{paddingLeft:"100px",marginBottom:"0px",marginTop:"10px"}}><strong>Joe butler</strong></p>
                            <p style={{paddingLeft:"100px"}}>cheif offices</p>
                            <hr />  
                            <p>"We selected Encora as our primary innovation partner because of their breadth of experience, depth of expertise, and consistent quality of service delivered by the team from their offshore center in the Philippines. Encora has been an integral part of our development and production support strategy."</p>
                        </div>
                    </div>

                </div>
            </div> */}

            {/* <div className="container-fluid">

<div className="row ">

    <div className="col-md-3">
        <div className="">
            <div className="card-body">
                <h3 className="card-title">Technology Consulting Services Success Stories </h3>
                <p className="card-text">Looking to expand knowledge, delve deeper into subjects, or embark on a new learning journey? Immerse in our meticulously curated resources, crafted by top industry professionals, and unveil new business alternatives.</p>
                <a href="#" className="btn btn-primary More-success-Stories">READ MORE</a>
            </div>
        </div>
    </div>
    {slider2.slice(currentIndex2, currentIndex2 + visibleSlides).map((slide) => (
        <div className="col-md-3 client-stories-card">
        <div className="card consulting-stories">
            <div>
                <h4 class="text-center">Floral eCommerce Company</h4>
            </div>
            <div style={{backgroundColor:"white",borderRadius:"20px",paddingBottom:"20px"}} className="card-body ">
                <h5 className="card-title">challenge</h5>
                <p className="card-text">{slide.text}.</p>
                
                <h5 className="card-title">Approach</h5>
                <p className="card-text">Identified an ownable space that could drive growth and separation from competitors.</p>

                <h5 className="card-title">Impact</h5>
                <a href="#" >LEARN MORE</a>
            </div>
            <a href="#" style={{marginTop:"20px"}} className="btn btn-primary More-success-Stories">READ MORE</a>
        </div>
    </div>
    ))}
    
    {/* <div className="col-md-3 client-stories-card">
        <div className="card consulting-stories">
            <div>
                <h4 class="text-center">Floral eCommerce Company</h4>
            </div>
            <div style={{backgroundColor:"white",borderRadius:"20px",paddingBottom:"20px"}} className="card-body ">
                <h5 className="card-title">challenge</h5>
                <p className="card-text">Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience.</p>
                
                <h5 className="card-title">Approach</h5>
                <p className="card-text">Identified an ownable space that could drive growth and separation from competitors.</p>

                <h5 className="card-title">Impact</h5>
                <a href="#" >LEARN MORE</a>
            </div>
            <a href="#" style={{marginTop:"20px"}} className="btn btn-primary More-success-Stories">READ MORE</a>
        </div>
    </div> */}
    {/* <div className="col-md-3 client-stories-card">
        <div className="card consulting-stories">
            <div>
                <h4 class="text-center">Floral eCommerce Company</h4>
            </div>
            <div style={{backgroundColor:"white",borderRadius:"20px",paddingBottom:"20px"}} className="card-body ">
                <h5 className="card-title">challenge</h5>
                <p className="card-text">Data fragmentation and associated analytical challenges, slower site performance, and a corresponding erosion of customer experience.</p>
                
                <h5 className="card-title">Approach</h5>
                <p className="card-text">Identified an ownable space that could drive growth and separation from competitors.</p>

                <h5 className="card-title">Impact</h5>
                <a href="#" >LEARN MORE</a>
            </div>
            <a href="#" style={{marginTop:"20px"}} className="btn btn-primary More-success-Stories">READ MORE</a>
        </div>
    </div> 


</div>
<div className="d-flex justify-content-end mt-3 pr-4">
    <button className="btn btn-primary mr-2" onClick={prevSlide2}>
        Previous
    </button>
    <button className="btn btn-primary" onClick={nextSlide2}>
        Next
    </button>
</div>
</div> */}

            {/* <div className="container-fluid">

                <div className="row client-Stories">

                    <div className="col-md-3">
                        <div className="">
                            <div className="card-body">
                                <h3 className="card-title">Innovation Ideation Resources </h3>
                                <p className="card-text">Looking to expand knowledge, delve deeper into subjects, or embark on a new learning journey? Immerse in our meticulously curated resources, crafted by top industry professionals, and unveil new business alternatives.</p>
                                <a href="#" className="btn btn-primary More-success-Stories">READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 client-stories-card">
                        <div className="card">
                            <img className="card-img-top" src="assets/movoto-background.png" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title">India</h5>
                                <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                                    (2x) India operations in the next 3 years</p>
                                <a href="#" >LEARN MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 client-stories-card">
                        <div className="card ">
                            <img className="card-img-top" src="assets/Sagent_background.png" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title">India</h5>
                                <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                                    (2x) India operations in the next 3 years</p>
                                <a href="#" >LEARN MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 client-stories-card">
                        <div className="card">
                            <img className="card-img-top" src="assets/Switchfly_Background.png" alt="Card image cap" />
                            <div className="card-body">
                                <h5 className="card-title">India</h5>
                                <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                                    (2x) India operations in the next 3 years</p>
                                <a href="#" >LEARN MORE</a>
                            </div>
                        </div>
                    </div>


                </div>
            </div> */}

<div className="container-fluid" style={{ paddingTop: "50px" }}>

<div className="row client-Stories">

    <div className="col-md-4">
        <div className="">
            <div className="card-body">
                <h3 className="card-title">Learn More About Shanvatech </h3>
                <p className="card-text">A dynamic digital engineering company driving modernization and innovation for global enterprises and digital-native businesses</p>
                <Link to="/About" className="btn btn-primary More-success-Stories">LEARN MORE</Link>
            </div>
        </div>
    </div>
    {slider1.slice(currentIndex, currentIndex + visibleSlides).map((slide) => (
        <div className="col-md-8 client-stories-card ">
            <div className="card story-image1" style={{ borderRadius: "50px" }}>
                {/* <img className="card-img-top" src={slide.src} alt="Card image cap" /> */}
                <div className="card-body" style={{ paddingTop: "400px" }}>
                    <h3 style={{ color: "white" }} className="card-title">India</h3>
                    {/* <p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
        (2x) India operations in the next 3 years</p> */}
                    <a href="#" >LEARN MORE</a>
                </div>
            </div>
        </div>
    ))}


    {/* <div className="col-md-3 client-stories-card">
<div className="card ">
<img className="card-img-top" src="assets/Sagent_background.png" alt="Card image cap" />
<div className="card-body">
<h5 className="card-title">India</h5>
<p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
(2x) India operations in the next 3 years</p>
<a href="#" >LEARN MORE</a>
</div>
</div>
</div> */}
    {/* <div className="col-md-3 client-stories-card">
<div className="card">
<img className="card-img-top" src="assets/Switchfly_Background.png" alt="Card image cap" />
<div className="card-body">
<h5 className="card-title">India</h5>
<p className="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
(2x) India operations in the next 3 years</p>
<a href="#" >LEARN MORE</a>
</div>
</div>
</div> */}


</div>

{/* <div className="d-flex justify-content-end mt-3 pr-4">
<button className="btn btn-primary mr-2" onClick={prevSlide1}>
Previous
</button>
<button className="btn btn-primary" onClick={nextSlide1}>
Next
</button>
</div> */}
</div>

            <ContactForm/>

        </>
    )
}

export default ApplicationAndProductMaintanence;